var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUs11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 404,
    viewBox: "0 0 1440 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 92.2313V404H0V226.33V111.48H46.5778V169.982H105.904L129.378 197.301H153.189V55.7613H207.979V92.2313H254.483V162.631H316.946V74.2973H366.243V111.459H391.877L414.068 85.6407H439.316V0H509.901V127.101H582.054V157.731H610.022V111.48H716.633V162.631H757.413V92.2313H819.612V197.301H823.245V55.7613H878.056V92.2313H924.538V162.631H986.986V74.2973H1036.28V111.459H1061.95L1084.14 85.6407H1109.37V0H1179.94V127.101H1252.13V157.731H1280.1V111.48H1336.23V162.631H1427.45V92.2313H1440Z",
    fill: "url(#paint0_linear_3618_4058)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 400.774V176.847H54.2352V229.45H116.55L135.567 248.467H342.347L374.519 216.301H439.464V162.277H496.255V235.117H600.844L641.148 194.813H770.472V262.731H827.934L855.902 234.758H926.667L946.697 254.794H1034.31V179.514H1096.62V204.361H1145.99V151.684H1191.31V231.299H1318.37L1330.26 243.181H1440V400.774H0Z",
    fill: "url(#paint1_linear_3618_4058)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3618_4058",
    x1: 719.997,
    y1: 55.1434,
    x2: 719.997,
    y2: 255.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3618_4058",
    x1: 719.997,
    y1: 141.043,
    x2: 719.997,
    y2: 308.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs11);
export default __webpack_public_path__ + "static/media/AboutUs_11.c31b823d778030864816771b5d7ef681.svg";
export { ForwardRef as ReactComponent };